import { ISagaModule } from 'redux-dynamic-modules-saga';
import { connectRouter } from 'connected-react-router';

import { alertsReducer } from 'common/components/notifications/reducer';
import { rootAlertSaga } from 'common/components/notifications/sagas';
import { workspacesReducer } from 'common/store/workspaces/reducer';
import { sessionReducer } from 'common/store/session/reducer';
import { fileUploadReducer } from 'common/store/fileUpload/reducer';
import { rootSessionSaga } from 'common/store/session/sagas';

import rootWorkspacesSaga from './workspaces/sagas';
import { RootState } from './rootReducer';
import { contextReducer } from './context/reducer';
import { customFieldsDefinitionReducer } from './customFieldsDefinition/reducer';
import { versionHistorySidebarReducer } from './versionHistorySidebar/reducer';

import history from '../services/HistoryService';
import { rootContextSaga } from './context/sagas';
import { rootCustomFieldsDefinitionSaga } from './customFieldsDefinition/saga';
import { rootVersionHistoryHeaderSaga } from './versionHistorySidebar/sagas';
import { CalibrationDataReducer } from './CalibrationTable/reducer';
import rootcalibrationDataSaga from './CalibrationTable/saga';
import rootSelectedQuestionDetailsSaga from './addStimulusToQuestion/saga';
import { SelectedQuestionDetailsReducer } from './addStimulusToQuestion/reducer';
import { notificationReducer } from './notification/reducer';

const getRootModule = (): ISagaModule<RootState> => ({
    id: 'root',
    reducerMap: {
        alerts: alertsReducer,
        context: contextReducer,
        customFieldsDefinition: customFieldsDefinitionReducer,
        versionHistory: versionHistorySidebarReducer,
        fileUpload: fileUploadReducer,
        router: connectRouter(history),
        session: sessionReducer,
        workspaces: workspacesReducer,
        calibrationData: CalibrationDataReducer,
        selectedQuestionDetailsState: SelectedQuestionDetailsReducer,
        notification: notificationReducer,
    },
    sagas: [
        rootAlertSaga,
        rootContextSaga,
        rootCustomFieldsDefinitionSaga,
        rootVersionHistoryHeaderSaga,
        rootSessionSaga,
        rootWorkspacesSaga,
        rootcalibrationDataSaga,
        rootSelectedQuestionDetailsSaga,
    ],
});

export default getRootModule;
